import React from 'react'
import CustomSection from "../../Components/Common/CustomSection"
import {privacyData} from "./Privacydata"


const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen px-[120px] py-8 mt-16">
      <div className="bg-white shadow-lg rounded-lg max-w-7xl mx-auto overflow-hidden">
        <div className="relative">
          <img
            src="https://img.freepik.com/free-vector/patient-studying-medical-checkup-list_74855-4450.jpg"
            alt="Privacy Policy"
            className="w-full h-72 object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-200">
              Privacy Policy
            </h1>
          </div>
        </div>
        <div className="p-8">
          <h2 className="text-2xl font-semibold mb-6 text-slate-600">
            Securing Your Information: Our Privacy Policy at Work
          </h2>
          {privacyData.map((section, index) => (
            <CustomSection key={index} title={section.title}>
              {section.detail}
            </CustomSection>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
